/**
 * Teen Zone Page
 * Onboarding flow to select age-based theme, then redirects to the real app
 * The selected theme is applied globally to all existing content (challenges, audios, resets)
 */

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { TeenThemeProvider, useTeenTheme } from '../contexts/TeenThemeContext';
import TeenOnboardingFlow from '../components/TeenOnboardingFlow';

// Inner component that uses the theme context
const TeenZoneContent = () => {
  const { isOnboarded, theme } = useTeenTheme();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const navigate = useNavigate();
  
  // Check if user is logged in
  const isLoggedIn = !!localStorage.getItem('reclaim_token');

  useEffect(() => {
    // Mark alignment as done for this session to prevent the global modal
    const today = new Date().toDateString();
    localStorage.setItem('reclaim_alignment_completed_today', 'true');
    localStorage.setItem('lastAlignmentDate', today);
    localStorage.setItem('reclaim_last_alignment', today);
    localStorage.setItem('alignment_check_date', today);
    
    // If already onboarded AND logged in, redirect to Teen content
    if (isOnboarded && isLoggedIn) {
      navigate('/teen');
    } else if (isOnboarded && !isLoggedIn) {
      // Onboarded but not logged in - redirect to login
      navigate('/login');
    } else {
      // Not onboarded - show onboarding flow
      setShowOnboarding(true);
    }
  }, [isOnboarded, isLoggedIn, navigate]);

  const handleOnboardingComplete = () => {
    // After completing onboarding, redirect to Teen content
    setShowOnboarding(false);
    if (isLoggedIn) {
      navigate('/teen');
    } else {
      navigate('/login');
    }
  };

  return (
    <div 
      className="min-h-screen transition-colors duration-500"
      style={{
        background: theme?.colors?.base || '#0F172A',
        color: theme?.colors?.textPrimary || '#F8FAFC',
      }}
    >
      <AnimatePresence mode="wait">
        {showOnboarding && (
          <TeenOnboardingFlow 
            key="onboarding"
            onComplete={handleOnboardingComplete} 
          />
        )}
      </AnimatePresence>
    </div>
  );
};

// Main page component with provider
const TeenZonePage = () => {
  return (
    <TeenThemeProvider>
      <TeenZoneContent />
    </TeenThemeProvider>
  );
};

export default TeenZonePage;
